
const initialState = {
  loading: false,
  newPass: false,
  error: false,
  removedExpiredAdsListing: [],
  removedExpiredAdsDetail: null,
  totalRemovedExpiredAds: 0,

};

const removedExpiredAdsReducer = (state = initialState, action) => {
  // console.log("bank  reducers------", state,action);
  switch (action.type) {
    case "ADD_REMOVED_EXPIRED_ADS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_REMOVED_EXPIRED_ADS_SUCCESS":
      return {
        ...state,
        loading: false,
        newPass: true,
        error: false,
      };
    case "ADD_REMOVED_EXPIRED_ADS_FAILED":
      return {
        ...state,
        loading: false,
        newPass: false,
        error: true,
      };

    case "GET_REMOVED_EXPIRED_ADS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_REMOVED_EXPIRED_ADS_REQUEST_FAILED":
      return {
        ...state,
        error: true,
      };
    case "GET_REMOVED_EXPIRED_ADS_REQUEST_SUCCESS":
      return {
        ...state,
        removedExpiredAdsListing: action.payload,
        loading: false,
        totalRemovedExpiredAds: action.total,

      };

    case "GOT_REMOVED_EXPIRED_ADS_DETAIL":
      return {
        ...state,
        removedExpiredAdsDetail: action.payload,
      };
    default:
      return state;
  }
};

export default removedExpiredAdsReducer;
